import React from "react";
import { Phone, ChevronRight, PhoneOff } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { Badge } from "../../../ui/badge";
import { Share2, Download, Trash2 } from "lucide-react";
import { Button } from "../../../ui/button";
import Image from "../../../Tags/Image";
export default function CallDetailsHeader({ callDetails, callMetadata }) {
  const navigate = useNavigate();
  const { workspaceSlug } = useParams();

  
  // console.log('=== CALL DETAILS HEADER DEBUG ===');
  // console.log('callDetails:', callDetails);
  // console.log('callMetadata:', callMetadata);
  // console.log('callMetadata phone data:', {
  //   from_number: callMetadata?.from_number,
  //   to_number: callMetadata?.to_number,
  //   call_direction: callMetadata?.call_direction
  // });

  const handleCallLogsClick = () => {
    navigate(`/${workspaceSlug}/call-logs`);
  };


  const getExternalPartyPhone = (item) => {
    if (item?.call_direction === 'Outgoing') {
      return item?.to_number || 'No Number';   
    } else {
      return item?.from_number || 'No Number'; 
    }
  };

  const getCallStatusLabel = (status) => {
    const statusLabels = {
      completed: "Completed call",
      missed: "Missed call", 
      ongoing: "Ongoing call",
      "brief call": "Brief call"
    };
    return statusLabels[status] || "Call";
  };

  const getCallStatusBadge = (status) => {
    const statusConfig = {
      completed: { variant: "success", label: "Outgoing call" },
      missed: { variant: "error", label: "Missed call" },
      ongoing: { variant: "warning", label: "Ongoing call" },
      "brief call": { variant: "default", label: "Brief call" }
    };
    
    return statusConfig[status] || { variant: "default", label: "Unknown" };
  };
  const getCallTypeIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "outgoing":
        return (
          <div className="h-12 w-12 rounded-full bg-green-100  flex items-center justify-center">
            <Image
              src="/images/icons/untitledui/call-logs/outgoing.svg" 
              alt="Completed call"
              className="h-6 w-6 no-invert"
            />
          </div>
        );
      case "Failed":
      case "missed":
        return (
          <div className="h-12 w-12 rounded-full bg-red-100 dark:bg-red-900 flex items-center justify-center">
            <Image
              src="/images/icons/untitledui/call-logs/failed.svg" 
              alt="Missed call"
              className="h-6 w-6 filter-red no-invert"
            />
          </div>
        );
      case "ongoing":
      case "in-progress":
        return (
          <div className="h-12 w-12 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
            <Image 
              src="/images/icons/untitledui/call-logs/ongoing.svg" 
              alt="Ongoing call"
              className="h-6 w-6 no-invert"
            />
          </div>
        );
      case "incoming":
        return (
          <div className="h-12 w-12 rounded-full bg-blue-100 dark:bg-blue-50 flex items-center justify-center">
            <Image 
              src="/images/icons/untitledui/call-logs/incoming.svg" 
              alt="Brief call"
              className="h-6 w-6 no-invert"
            />
          </div>
        );
      default:
        return (
          <div className="h-12 w-12 rounded-full bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
            <PhoneOff className="h-6 w-6 text-gray-600 dark:text-gray-400" />
          </div>
        );
    }
  };
  // Handle cases where callDetails might be null (404 scenarios)
  // Prioritize callMetadata (from telephony API) for call direction and phone numbers
  const effectiveCallData = callMetadata || callDetails || {};
  const statusConfig = getCallStatusBadge(effectiveCallData.call_status);
  const callDirection = effectiveCallData.call_direction || 'Unknown';
  const externalPhone = getExternalPartyPhone(effectiveCallData);
  const contactName = callDetails?.contact_name || callDetails?.user_name || 'Unknown Contact';

  return (
    <div className="space-y-4 border-b">
  
      <div className="flex items-center justify-between">
        <nav className="flex items-center space-x-2 text-sm">
          <button 
            onClick={handleCallLogsClick}
            className="text-gray-500 hover:text-gray-700 dark:text-[#FFFFFF] dark:hover:text-gray-300 transition-colors"
          >
            Call logs
          </button>
          <ChevronRight className="h-4 w-4 text-gray-400" />
          <span className="text-[#6941C6] dark:text-[#FFFFFF] font-semibold">
            {callDirection} with {externalPhone}
          </span>
        </nav>
      </div>

 
      <div className=" py-4">
        <div className="flex items-start justify-between">
          
          <div className="flex items-center space-x-4">
          
            {getCallTypeIcon(callDirection)}
            
        
            <div>
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
              Unknown Contact
              </h1>
              <div className="flex items-center space-x-2 mt-1">
                {effectiveCallData.country_flag && (
                  <span className="text-base">{effectiveCallData.country_flag}</span>
                )}
                <span className="text-sm text-gray-500 dark:text-[#94979C] font-mono">
                  {externalPhone}
                </span>
              </div>
            </div>
          </div>

          {/* Call Status Badge */}
          {/* <div className="flex items-center justify-end">
          <div className="flex items-center space-x-3">
            <Button variant="outline" size="sm" className="bg-[#7F56D9] text-white border-[#FFFFFF1F] shadow-sm">
              <Share2 className="h-4 w-4 " />
            </Button>
            <Button variant="outline" size="sm">
              <Download className="h-4 w-4" />
            </Button>
            <Button variant="outline" size="sm">
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div> */}
        </div>
      </div>
    </div>
  );
} 